import React from 'react';
import { Card, Tag, Avatar } from 'antd';
import { ExperimentOutlined, CalendarOutlined, ApartmentOutlined, NumberOutlined, PhoneOutlined } from '@ant-design/icons';
import s from './index.module.css';

const STATUS_TEXT = {
  1: '正常使用',
  2: '待用/检修中',
  3: '停用',
};

const formatDay = (value) => {
  if (!value) return '-';
  return String(value).slice(0, 10);
};

const DeviceCard = ({ device, onClick }) => {
  const {
    deviceName, deviceModel, deviceNo, manufacturer, industryType, industryType_dictText,
    manageType, deviceStatus, validEndDate, orgName, labName, deviceImg,
    orgTel, orgContact, contactTel,
  } = device || {};
  const industryText = industryType_dictText || '-';
  const statusText = STATUS_TEXT[deviceStatus] || '-';
  const expired = Number(device?.expired) === 1 || (device?.expireStatus === 2);
  const phoneText = orgTel || contactTel || '';
  const contactText = [orgContact && `联系人：${orgContact}`, phoneText && `电话：${phoneText}`].filter(Boolean).join('  ');

  return (
    <Card
      className={s.deviceCard}
      hoverable
      bodyStyle={{ padding: '16px' }}
      onClick={() => onClick && onClick(device)}
    >
      <div className={s.deviceContent}>
        <div className={s.deviceHeader}>
          <div className={s.deviceIcon}>
            {deviceImg ? (
              <img src={deviceImg} alt={deviceName} className={s.deviceImg} />
            ) : (
              <Avatar size={48} style={{ background: 'var(--color-primary)' }} icon={<ExperimentOutlined />} />
            )}
          </div>
          <h4 className={s.deviceName} title={deviceName}>{deviceName || '未命名设备'}</h4>
        </div>

        <div className={s.deviceTags}>
          {industryText !== '-' && <Tag color="blue" className={s.typeTag}>{industryText}</Tag>}
          {expired ? (
            <Tag color="red" className={s.typeTag}>已过期</Tag>
          ) : (
            <Tag color={deviceStatus === 1 ? 'green' : deviceStatus === 2 ? 'orange' : 'red'} className={s.typeTag}>
              {statusText}
            </Tag>
          )}
        </div>

        <div className={s.deviceInfo}>
          <div className={s.infoItem}>
            <ApartmentOutlined className={s.infoIcon} />
            <span className={s.infoText} title={orgName}>{orgName || '-'}</span>
          </div>
          {labName && (
            <div className={s.infoItem}>
              <span className={s.infoText} title={labName}>{labName}</span>
            </div>
          )}
          {deviceModel && (
            <div className={s.infoItem}>
              <NumberOutlined className={s.infoIcon} />
              <span className={s.infoText}>型号：{deviceModel}</span>
            </div>
          )}
          {manufacturer && (
            <div className={s.infoItem}>
              <span className={s.infoText}>厂家：{manufacturer}</span>
            </div>
          )}
          {contactText && (
            <div className={s.infoItem}>
              <PhoneOutlined className={s.infoIcon} />
              <span className={s.infoText}>
                {phoneText ? (
                  <a
                    className={s.telLink}
                    href={`tel:${phoneText}`}
                    onClick={(e) => e.stopPropagation()}
                    title={contactText}
                  >
                    {contactText}
                  </a>
                ) : (
                  <span title={contactText}>{contactText}</span>
                )}
              </span>
            </div>
          )}
        </div>

        <div className={s.deviceFooter}>
          <div className={s.footerItem}>
            <CalendarOutlined className={s.footerIcon} />
            <span className={s.footerText}>有效期至 {formatDay(validEndDate)}</span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default DeviceCard;
